import { ArrowIcon, Flex, Text } from '@modusign/design-system';

interface StepProgressBarProps {
  currentStepIndex: number;
  steps: string[];
}

function StepProgressBar({ currentStepIndex, steps }: StepProgressBarProps) {
  return (
    <>
      {steps.map((step, index) => {
        const isActive = index + 1 === currentStepIndex;
        return (
          <Flex alignItems="center" key={step} minWidth="max-content" position="relative">
            <Flex
              alignItems="center"
              bg={isActive ? 'white' : 'iconNeutralDark'}
              borderRadius="50%"
              color="textNeutralDark"
              justifyContent="center"
              minHeight="22px"
              minWidth="22px"
              mr={2}
            >
              <Text fontWeight="medium">{index + 1}</Text>
            </Flex>
            <Text
              as="span"
              color={isActive ? 'white' : 'textNeutralLight'}
              fontSize="lg"
              fontWeight="medium"
            >
              {step}
            </Text>
            {index + 1 < steps.length && (
              <ArrowIcon color="iconNeutralSlightlyDark" direction="right" mx="14px" />
            )}
          </Flex>
        );
      })}
    </>
  );
}

export default StepProgressBar;
